import React, { useState, useEffect } from 'react'
import { Accordion } from 'flowbite-react'
import { useAllSelector } from '../../services/selectors/allSelector'
import { uploadImage } from '../../services/apis/setting/uploadImage'
import { useDispatch } from 'react-redux'
import { getDriverProfile } from '../../services/apis/setting/getDriverProfile'
const UploadImage = () => {
    const {getDriverProfileResponse} = useAllSelector()
    const [identity1, setIdentity1] = useState(null)
    const [identity2, setIdentity2] = useState(null)
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    // Add these state variables at the top of your component
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const dispatch = useDispatch()


    

    const uploadProfileImage = async (file, type) => {
        const formData = new FormData();

        if (type === 'identity1') {
            formData.append('document_type_1', file);
        } else {
            formData.append('document_type_2', file);
        }

        // Convert FormData to object and log it
        const formDataObject = Object.fromEntries(formData.entries());
      

        try {
            const response = await dispatch(uploadImage(formData));
            if (response?.payload?.success) {
                dispatch(getDriverProfile())
                setSuccessMessage(type === 'identity1' 
                    ? 'Identity Document 1 uploaded successfully' 
                    : 'Identity Document 2 uploaded successfully'
                );
                setErrorMessage('');
            }
            return response;
        } catch (error) {
            setErrorMessage('Upload failed. Please try again.');
            setSuccessMessage('');
            throw error;
        }
    };

    // Add this function at the top of your component
    const validateImageType = (file) => {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            setErrorMessage('');
            return false;
        }
        return true;
    };

// Update handleIdentityChange
const handleIdentityChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;
    
    // Reset messages
    setSuccessMessage('');
    setErrorMessage('');
    
    // Validate image type
    if (!validateImageType(file)) {
        e.target.value = ''; // Reset input
        setErrorMessage('Please upload only JPEG, JPG or PNG format images');
        return;
    }
    
    const setLoading = type === 'identity1' ? setLoading1 : setLoading2;
    const setIdentity = type === 'identity1' ? setIdentity1 : setIdentity2;
    const currentIdentity = type === 'identity1' ? identity1 : identity2;

    if (currentIdentity) {
        URL.revokeObjectURL(URL.createObjectURL(currentIdentity));
    }

    setErrorMessage('');
    setLoading(true);
    try {
        setIdentity(file);
        await uploadProfileImage(file, type);
    } catch (error) {
        console.error('Upload error:', error);
        setIdentity(null);
        setErrorMessage(type === 'identity1' 
            ? 'Failed to upload Identity Document 1' 
            : 'Failed to upload Identity Document 2'
        );
    } finally {
        setLoading(false);
    }
}

    // Cleanup effect for object URLs
    useEffect(() => {
        return () => {
            if (identity1) URL.revokeObjectURL(URL.createObjectURL(identity1));
            if (identity2) URL.revokeObjectURL(URL.createObjectURL(identity2));
        };
    }, []);

    // Use the common function with different type parameters
    const handleIdentity1Change = (e) => handleIdentityChange(e, 'identity1');
    const handleIdentity2Change = (e) => handleIdentityChange(e, 'identity2');

    return (
        <Accordion collapseAll={true} className='shadow-sm bg-white overflow-hidden mt-3 border-none divide-dashed px-4'>
            <Accordion.Panel>
                <Accordion.Title className='bg-white hover:bg-white p-2.5 px-0 focus:ring-0'>
                    Upload Identity Documents
                </Accordion.Title>
                <Accordion.Content className='px-0 py-4'>
                    {errorMessage && (
                            <div className="text-red-500 text-sm mb-2 px-2">
                                {errorMessage}
                            </div>
                        )}
                        {successMessage && (
                            <div className="text-green-500 text-sm mb-2 px-2">
                                {successMessage}
                            </div>
                        )}
                    <div className="flex gap-4">
                        <div className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-500 transition-colors">
                            <label className={`block cursor-pointer ${loading1 ? 'opacity-50' : ''}`}>
                                <div className="text-center">
                                    {identity1 ? (
                                        <div className="mb-2 h-24 w-full relative">
                                            <img
                                                key={identity1.name} // Add key to force re-render on new file
                                                src={URL.createObjectURL(identity1)}
                                                alt="Preview"
                                                className="h-full mx-auto object-contain"
                                            />
                                            {loading1 && (
                                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded">
                                                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="mb-2">
                                            <svg className="mx-auto h-8 w-8 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    )}
                                    <div className="text-gray-600 font-medium text-sm">Identity Document 1</div>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {loading1 ? 'Uploading...' : 'Click to upload'}
                                    </p>
                                </div>
                                <input
                                    type="file"
                                    onChange={handleIdentity1Change}
                                    className="hidden"
                                    accept=".jpg, .jpeg, .png"
                                    disabled={loading1}
                                />
                            </label>
                        </div>

                        <div className="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-500 transition-colors">
                            <label className={`block cursor-pointer ${loading2 ? 'opacity-50' : ''}`}>
                                <div className="text-center">
                                    {identity2 ? (
                                        <div className="mb-2 h-24 w-full relative">
                                            <img
                                                key={identity2?.name} // Add key to force re-render on new file
                                                src={URL.createObjectURL(identity2)}
                                                alt="Preview"
                                                className="h-full mx-auto object-contain"
                                            />
                                            {loading2 && (
                                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded">
                                                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="mb-2">
                                            <svg className="mx-auto h-8 w-8 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                    )}
                                    <div className="text-gray-600 font-medium text-sm">Identity Document 2</div>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {loading2 ? 'Uploading...' : 'Click to upload'}
                                    </p>
                                </div>
                                <input
                                    type="file"
                                    onChange={handleIdentity2Change}
                                    className="hidden"
                                    accept=".jpg, .jpeg, .png"
                                    disabled={loading2}
                                />
                            </label>
                        </div>
                    </div>
                </Accordion.Content>
            </Accordion.Panel>
        </Accordion>
    )
}

export default UploadImage;